<div>
    <section *ngIf="!checkoutProcessView" class="flex flex-col">
        <div class="justify-center flex" *ngIf="!validPayment  && !dashboardProcessView">
            <fuse-card class="md:w-3/4 p-4 bg-red-600">
                <div class="flex flex-row max-sm:flex-col">
                    <div class="flex md:flex-row items-center">
                        <mat-icon class="bg-green-50 text-red-600 rounded-full scale-110 mr-4">error</mat-icon>
                        <div class="flex-col flex">
                            <h1 class="text-lg font-bold text-white">
                                No banking details provided
                            </h1>
                            <p class="text-white">
                                Please add banking details
                            </p>
                        </div>
                    </div>
                    <h1 class="cursor-pointer mt-2 md:mx-24 text-white text-lg max-sm:text-center"
                        *ngIf="dashboardProcessView" (click)="addPaymentMethod(addPaymentDialog)">
                        <u>
                            Add payment details
                        </u>
                    </h1>
                </div>
            </fuse-card>
        </div>
        <div class="justify-center flex" *ngIf="validPayment">
            <fuse-card class="w-full p-4 bg-green-600 ">
                <div class="flex-row text-center flex w-full justify-center items-center">
                    <mat-icon class="bg-green-50 text-green-600 rounded-full scale-110 mr-4">check_circle</mat-icon>
                    <p class="text-white max-sm:text-sm max-sm:text-left" *ngIf="currentPaymentMethod.PaymentMethod !== 'CreditCard'">
                        Your payment details for all current services and orders is a bank account ({{
                        currentPaymentMethod.BankName + ': ' + currentPaymentMethod.BankAccountNumber }})
                        <span *ngIf="dashboardProcessView">
                            You can change this anytime <a class='cursor-pointer'
                                (click)="addPaymentMethod(addPaymentDialog)"><u class="text-md font-bold">here</u></a>
                        </span>
                    </p>
                    <p class="text-white max-sm:text-sm max-sm:text-left" *ngIf="currentPaymentMethod.PaymentMethod == 'CreditCard'">
                        Your payment details for all current services and orders is a credit card ({{
                        currentPaymentMethod.CreditCardType + ': ' + currentPaymentMethod.CreditCardNumberMasked }})
                        <span *ngIf="dashboardProcessView">
                            You can change this anytime <a class='cursor-pointer'
                                (click)="addPaymentMethod(addPaymentDialog)"><u class="text-md font-bold">here</u></a>
                        </span>
                    </p>
                </div>
            </fuse-card>
        </div>
        <div class="flex flex-row justify-center mt-12 max-sm:flex-col md:space-x-4 max-sm:space-y-4"
            *ngIf="!dashboardProcessView">
            <button class="mt-2 text-lg bg-primary text-white" mat-flat-button
                (click)="changeDebitDate(debitOrderDate)">
                Change debit order date
            </button>
            <button class="mt-2 text-lg bg-accent" mat-flat-button (click)="addPaymentMethod(addPaymentDialog)">
                <p *ngIf="!validPayment">
                    Add payment details
                </p>
                <p *ngIf="validPayment">
                    Change payment details
                </p>
            </button>
        </div>
    </section>
</div>

<div *ngIf="checkoutProcessView && validPayment">
    <fuse-card class="w-full flex flex-col p-4"
    >
        <div class="flex flex-row">
            <div class="flex flex-col w-full">
                <div class="flex flex-row">
                    <div class="flex w-10 h-10 justify-center items-center bg-primary-200 rounded-full mr-2 md:mr-8">
                        <mat-icon svgIcon="heroicons_solid:credit-card" [color]="'primary'"></mat-icon>
                    </div>
                    <div class="flex flex-row font-bold text-black text-2xl">
                        Banking details
                    </div>
                </div>

                <hr class="my-5">

                <div
                    class="flex flex-row font-base text-black border border-gray-500 rounded-2xl px-2 md:px-8 md:py-4 justify-between items-center">
                    <div class="mr-8">
                        <mat-icon svgIcon="heroicons_solid:check-circle" class="text-green-500"></mat-icon>
                    </div>
                    <div class="flex flex-col py-2 mr-8 text-start">
                        <div class="flex flex-row">
                            {{currentPaymentMethod.BankName ? currentPaymentMethod.BankName : currentPaymentMethod.CreditCardType}}
                        </div>
                        <div class="flex flex-row">
                            {{currentPaymentMethod.BankAccountType ? currentPaymentMethod.BankAccountType : currentPaymentMethod.PaymentMethodName}}
                        </div>
                        <div class="flex flex-row" *ngIf="currentPaymentMethod.PaymentMethod !== 'CreditCard'">
                            ********{{currentPaymentMethod.BankAccountNumber | slice:-4}}
                        </div>
                        <div class="flex flex-row" *ngIf="currentPaymentMethod.PaymentMethod == 'CreditCard'">
                            {{currentPaymentMethod.CreditCardNumberMasked}}
                        </div>

                    </div>
                    <div (click)="addPaymentMethod(addPaymentDialog)" class="hover:cursor-pointer">
                        <mat-icon svgIcon="heroicons_solid:chevron-right"></mat-icon>
                    </div>
                </div>

                <div class="flex flex-row pt-4 justify-center items-center md:justify-start">
                    <button [disabled]="btnLoading" class="font-bold" mat-flat-button [color]="'accent'" (click)="addPaymentMethod(addPaymentDialog)">
                        Change payment details
                    </button>
                </div>
            </div>

        </div>
    </fuse-card>
</div>

<div *ngIf="checkoutProcessView && !validPayment">
    <fuse-card class="flex flex-col p-4">

        <div class="flex flex-row">

            <div class="flex flex-col w-full">

                <div class="flex flex-row">
                    <div class="flex w-10 h-10 justify-center items-center bg-primary-200 rounded-full mr-8">
                        <mat-icon svgIcon="heroicons_solid:credit-card" [color]="'primary'"></mat-icon>
                    </div>
                    <div class="flex flex-row font-bold text-black text-2xl">
                        Banking details
                    </div>
                </div>

                <hr class="my-5">

                <div class="flex flex-row w-full font-extrabold text-black text-2xl pb-8">
                    No payment details
                </div>
                <div class="flex flex-row w-full">
                    <div class="flex flex-col text-black">
                        Please add your preferred method of payment
                    </div>
                </div>

                <div class="flex flex-row pt-8">

                    <button mat-flat-button [color]="'accent'" (click)="addPaymentMethod(addPaymentDialog)" class="font-bold">
                        Add payment details
                    </button>
                </div>
            </div>

        </div>
    </fuse-card>
</div>

<ng-template #addPaymentDialog>
    <div class="z-99 fixed top-0 right-0 p-2" *ngIf="showAlert">
        <fuse-alert (dismissedChanged)="showAlert = !$event" [dismissible]="true" class="shadow-lg"
            [appearance]="'soft'" [showIcon]="true" [type]="alert.type">
            {{alert.message}}
        </fuse-alert>
    </div>

    <mat-dialog-content class="p-4">

        
        
        <div class="border-b-2 pb-5">
            <h1 class="text-xl md:text-2xl pb-5 font-bold">Add payment details</h1>
            <h3 class="text-base">Please define how you would like to pay for your package(s). Please note this will
                become your payment details for any other services and orders you have currently.</h3>
        </div>


        <!-- Toggle -->
         <div class="w-full flex lg:justify-start justify-center pt-5">
             <div class="lg:w-1/2 w-full flex flex-row border-primary border-1 text-center rounded-full lg:mr-12 my-2 hover:cursor-pointer">
                 <div 
                    (click)="changePaymentMethod('BankAccount')" 
                    [ngClass]="selectedPaymentMethod === 'BankAccount' ? 'bg-primary text-white' : 'bg-slate-200 text-primary'" 
                    class="w-1/2 font-bold rounded-l-full lg:text-xl text-md py-2">
                    Bank Account
                </div>
                 <div 
                    (click)="changePaymentMethod('CreditCard')" 
                    [ngClass]="selectedPaymentMethod === 'CreditCard' ? 'bg-primary text-white' : 'bg-slate-200 text-primary'" 
                    class="w-1/2 font-bold rounded-r-full lg:text-xl text-md py-2">
                    Credit Card
                </div>
             </div>
         </div>



        <ng-container *ngIf="selectedPaymentMethod === 'BankAccount'">
            <div class="py-5">
                <h1 class="text-xl md:text-2xl pb-5 font-bold">Bank account details:</h1>
                <h3 class="text-base">
                    Please note that this will become your default payment details for any orders you currently have and any
                    new services you add.
                </h3>
            </div>
    
            <!-- bank details form -->
            <form [formGroup]="addPaymentForm">
                <div class="flex flex-col">
                    <div class="flex lg:flex-row flex-col lg:space-x-4">
                        <mat-form-field class="w-full">
                            <mat-label class="max-sm:text-md">Bank:</mat-label>
                            <mat-select matNativeControl required formControlName="bank">
                                <mat-option selected disabled> -- PLEASE SELECT -- </mat-option>
                                <mat-option *ngFor="let b of bankList" [value]="b">{{ b.BankName }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field class="w-full">
                            <mat-label class="max-sm:text-md">Bank account type:</mat-label>
                            <mat-select matNativeControl required formControlName="bankType">
                                <mat-option selected disabled> -- PLEASE SELECT -- </mat-option>
                                <mat-option *ngFor="let ba of bankAccountList" [value]="ba.Value">{{ ba.Description }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="flex lg:flex-row flex-col lg:space-x-4">
                        <mat-form-field class="w-full">
                            <mat-label class="max-sm:text-md">Account number</mat-label>
                            <input matInput formControlName="accountNumber" type="number">
                        </mat-form-field>
                        <mat-form-field class="w-full">
                            <mat-label class="max-sm:text-md">Account holder name:</mat-label>
                            <input matInput formControlName="accountHolder" type="text">
                        </mat-form-field>
                    </div>
    
                    <!-- Debit order date update -->
                    <div class="flex flex-col w-full lg:justify-start">
                        <mat-form-field class="w-full">
                            <mat-label class="max-sm:text-md">On which date do you want to be debited?</mat-label>
                            <mat-select required formControlName="collectionRuns">
                                <mat-option selected disabled> -- PLEASE SELECT -- </mat-option>
                                <mat-option *ngFor="let collectionRun of collectionRuns" [value]="collectionRun">
                                    {{ collectionRun.Description }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            
                <div *ngIf="!bankIsValidated && !loading">
                    <p class="text-red-500">{{errorMessage}}</p>
                </div>
            
                <!-- add payment method button -->
                <div class="py-5 flex justify-end">
                    <button
                        disabled
                        *ngIf="loading"
                        class="w-full rounded-xl font-bold" mat-raised-button color="primary">
                        <mat-progress-spinner [diameter]="24"
                                [mode]="'indeterminate'">
                            </mat-progress-spinner>
                    </button>
                    <button (click)="submitPaymentMethod()" [disabled]="addPaymentForm?.invalid"
                        *ngIf="!loading"
                        class="w-full rounded-xl font-bold" mat-raised-button color="primary">
                        Add payment details
                    </button>
                </div>
            
                <div class="py-5 flex justify-end" *ngIf="!bankIsValidated">
                    <button (click)="closeDialog()"
                        class="w-full rounded-xl font-bold" mat-raised-button color="primary">
                        Close
                    </button>
                </div>
            </form>
        </ng-container>

        <ng-container *ngIf="selectedPaymentMethod === 'CreditCard'">
            <div class="py-5">
                <h1>Add a Credit Card:</h1>
                <h2 class="font-bold mt-3">Card Validation Notice</h2>
                <h3 class="text-base">
                    To set up your credit card debit order, a <b>R1.00</b> transaction will be processed and immediately reversed.<br>
                    This is to verify that your card details are valid. There’s no charge, and no action is required from your side
                    <!-- Please add your card details through our payment gateway. You will be directed to Netcash to make a <b>R1</b> payment to verify your credit card is valid. -->
                </h3>
            </div>

            <!-- Debit order date update -->
            <form [formGroup]="addPaymentForm">
                <mat-form-field class="w-full justify-center mt-4">
                    <mat-label class="max-sm:text-md">Collection Run Date</mat-label>
                    <mat-select matNativeControl required formControlName="collectionRuns">
                        <mat-option selected disabled> -- PLEASE SELECT -- </mat-option>
                        <mat-option *ngFor="let el of collectionRuns" [value]="el">{{ el.Description}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </form>


            <div class="w-full flex flex-row justify-end p-4">
                <img class="w-30 h-auto" src="./assets/images/netcash.png" alt="netcash_logo">
            </div>


            <div class="py-5 flex w-full justify-end">
                <div class="flex flex-row space-x-2 w-1/2 justify-center items-center">
                    <button (click)="closeDialog()"
                        class="w-full rounded-full font-bold bg-slate-200 hover:cursor-pointer" mat-raised-button>
                        CANCEL
                    </button>
                    <button (click)="submitCreditMethod()"
                        [disabled]="!addPaymentForm?.value?.collectionRuns"
                        class="w-full rounded-full font-bold hover:cursor-pointer" mat-raised-button color="primary">
                        PROCEED TO NETCASH
                    </button>
                </div>
            </div>


        </ng-container>


        

    </mat-dialog-content>
</ng-template>





<ng-template #debitOrderDate>
    <mat-dialog-content class="p-0">
        <div class="border-b-2 pb-5">
            <h1 class="text-xl md:text-2xl pb-5 font-bold">Change Debit Order Date?</h1>
            <h3 class="text-base">Determine when you would like to be debited for your package(s)</h3>
        </div>
        <!-- bank details form -->
        <form [formGroup]="debitOrderForm">
            <mat-form-field class="w-full justify-center mt-4">
                <mat-label class="max-sm:text-md">Collection Run Date</mat-label>
                <mat-select matNativeControl required formControlName="collectionRuns">
                    <mat-option selected disabled> -- PLEASE SELECT -- </mat-option>
                    <mat-option *ngFor="let el of collectionRuns" [value]="el">{{ el.Description
                        }}</mat-option>
                </mat-select>
            </mat-form-field>
            <!-- add payment method button -->
            <div class="py-5 flex justify-end">
                <button [disabled]="debitOrderForm?.invalid" class="mt-5 w-full rounded-xl" mat-raised-button
                    (click)="changeDebitOrderDate()" [color]="'primary'">
                    SAVE CHANGES
                </button>
            </div>
        </form>
    </mat-dialog-content>
</ng-template>